import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGitMerge = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		d: "M4.75 7a.75.75 0 0 0-1.5 0h1.5Zm-1.5 6a.75.75 0 0 0 1.5 0h-1.5ZM4 7h-.75v6h1.5V7H4Zm0 5h-.75v1h1.5v-1H4Zm9.75-2v-.75H6v1.5h7.75V10ZM6 10v-.75A2.75 2.75 0 0 0 3.25 12h1.5c0-.69.56-1.25 1.25-1.25V10Zm.25 6H5.5A1.5 1.5 0 0 1 4 17.5V19a3 3 0 0 0 3-3h-.75ZM4 18.25v-.75A1.5 1.5 0 0 1 2.5 16H1a3 3 0 0 0 3 3v-.75ZM1.75 16h.75A1.5 1.5 0 0 1 4 14.5V13a3 3 0 0 0-3 3h.75ZM4 13.75v.75A1.5 1.5 0 0 1 5.5 16H7a3 3 0 0 0-3-3v.75ZM18.25 10h-.75a1.5 1.5 0 0 1-1.5 1.5V13a3 3 0 0 0 3-3h-.75ZM16 12.25v-.75a1.5 1.5 0 0 1-1.5-1.5H13a3 3 0 0 0 3 3v-.75ZM13.75 10h.75A1.5 1.5 0 0 1 16 8.5V7a3 3 0 0 0-3 3h.75ZM16 7.75v.75a1.5 1.5 0 0 1 1.5 1.5H19a3 3 0 0 0-3-3v.75ZM6.25 4H5.5A1.5 1.5 0 0 1 4 5.5V7a3 3 0 0 0 3-3h-.75ZM4 6.25V5.5A1.5 1.5 0 0 1 2.5 4H1a3 3 0 0 0 3 3v-.75ZM1.75 4h.75A1.5 1.5 0 0 1 4 2.5V1a3 3 0 0 0-3 3h.75ZM4 1.75v.75A1.5 1.5 0 0 1 5.5 4H7a3 3 0 0 0-3-3v.75Z"
	})]
});
const ForwardRef = forwardRef(SvgGitMerge);
export { ForwardRef as ReactComponent };
